import researchImg from "../../assets/images/news-research.jpg";
import outreachImg from "../../assets/images/anaesthetic.jpg";
import graduationImg from "../../assets/images/community.jpg";

export const newsItems = [
  {
    id: 1,
    title: "LUTH Launches New Medical Research Center",
    date: "July 15, 2025",
    summary:
      "Lagos University Teaching Hospital has inaugurated a state-of-the-art research facility aimed at advancing medical studies in West Africa.",
    img: researchImg,
  },
  {
    id: 2,
    title: "Community Health Outreach Success",
    date: "July 10, 2025",
    summary:
      "The School of Community Health conducted a successful outreach program benefiting over 500 residents in Lagos suburbs.",
    img: outreachImg,
  },
  {
    id: 3,
    title: "Biomedical Engineering Graduates 120 Students",
    date: "July 8, 2025",
    summary:
      "The Federal School of Biomedical Engineering celebrated the graduation of its largest cohort to date, with students going on to internships globally.",
    img: graduationImg,
  },
  {
    id: 4,
    title: "Biomedical Engineering Graduates 120 Students",
    date: "July 8, 2025",
    summary:
      "The Federal School of Biomedical Engineering celebrated the graduation of its largest cohort to date, with students going on to internships globally.",
    img: graduationImg,
  },
  {
    id: 5,
    title: "Biomedical Engineering Graduates 120 Students",
    date: "July 8, 2025",
    summary:
      "The Federal School of Biomedical Engineering celebrated the graduation of its largest cohort to date, with students going on to internships globally.",
    img: graduationImg,
  },
  {
    id: 6,
    title: "Biomedical Engineering Graduates 120 Students",
    date: "July 8, 2025",
    summary:
      "The Federal School of Biomedical Engineering celebrated the graduation of its largest cohort to date, with students going on to internships globally.",
    img: graduationImg,
  },
];

export default newsItems;
